import React, { useEffect } from "react";

import { useGeneralContext, useGetCarbonProgramByFarmId, useTranslation, useUserContext } from "utils";

import { MainPage } from "components";

import ContactFooter from "pages/app/home/components/ContactFooter";
import HomePageFarmList from "pages/app/home/components/HomePageFarmList";
import { HomePagePlanningList } from "pages/app/home/components/HomePagePlanningList.tsx";
import { HomeSubmissionBanner } from "pages/app/home/components/HomeSubmissionBanner";
import NewsAndArticles from "pages/app/home/components/NewsAndArticles";
import OnboardingBanner from "pages/app/home/components/OnboardingBanner";

const Home: React.FC = () => {
  const { t } = useTranslation([]);
  const { setAppNavSideCollapsed } = useGeneralContext();
  const { user } = useUserContext();

  const { data: carbonProgram, isLoading: isLoadingCarbonProgram } = useGetCarbonProgramByFarmId(user?.farm.id ?? undefined);

  const farmHasFields = !!user?.farm?.fields && user?.farm?.fields > 0;

  useEffect(() => {
    setAppNavSideCollapsed(true);
  }, [setAppNavSideCollapsed]);

  const navigationCrumbs = {
    crumbs: [{ name: t("global:header.home"), link: "/home" }],
  };

  return (
    <MainPage pageName="Home" navigationCrumbs={navigationCrumbs} showMobileAlert>
      {isLoadingCarbonProgram || !carbonProgram || !farmHasFields || carbonProgram.platformFeatures.fieldManagement?.removalsExperience === false ? (
        <OnboardingBanner />
      ) : (
        <HomeSubmissionBanner />
      )}
      <HomePageFarmList />
      <HomePagePlanningList />
      <NewsAndArticles />
      <ContactFooter />
    </MainPage>
  );
};

export default Home;
